import { render, staticRenderFns } from "./LiveEditorDialog.vue?vue&type=template&id=00b8ae67&scoped=true"
import script from "./LiveEditorDialog.vue?vue&type=script&lang=js"
export * from "./LiveEditorDialog.vue?vue&type=script&lang=js"
import style0 from "./LiveEditorDialog.vue?vue&type=style&index=0&id=00b8ae67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b8ae67",
  null
  
)

export default component.exports